import {useRef} from 'react';

/**
 *
 * This hook allows you to access latest values inside hooks with dependency arrays, without having updates trigger them.
 *
 * @example
 * const {foo, bar, wizbiz} = props;
 * const myCoolFunction = () => {
 *   dispatch(coolAction(foo, bar));
 * }
 * const reffedFunction = useEncapsulateRef(myCoolFunction);
 * // This effect will only run on mount and when `wizbiz` changes
 * useEffect(() => {
 *   reffedFunction.current(wizbiz)
 * }, [wizbiz]);
 *
 * @param value Any value that you wish to use in memoized hooks without triggering a render/update
 */
export const useEncapsulateRef = <T>(value: T) => {
    const ref = useRef(value);
    ref.current = value;
    return ref;
};
